/**
 * Match data for the challenges list.
 * Builds matchesMap from embedded match data in challenges (GET /challenges already
 * includes picks[].match). No separate API call needed.
 */

import { useMemo } from 'react';
import type { ChallengeWithStats } from '../../../types/challenges';

interface UseChallengesMatchDataReturn {
  matchesMap: Record<string, unknown>;
}

export const useChallengesMatchData = (
  challenges: ChallengeWithStats[]
): UseChallengesMatchDataReturn => {
  const matchesMap = useMemo(() => {
    const map: Record<string, unknown> = {};
    for (const challenge of challenges) {
      const picks = Array.isArray(challenge.picks) ? challenge.picks : [];
      for (const p of picks) {
        const match = (p as { matchId?: string; match?: unknown }).match;
        const matchId = (p as { matchId?: string; match?: unknown }).matchId;
        if (matchId && match && !map[matchId]) {
          map[matchId] = match;
        }
      }
    }
    return map;
  }, [challenges]);

  return { matchesMap };
};
